export default __webpack_public_path__ + "static/media/footer1.50b47f07.png";